import { ProctoringSessionSummary } from "@verity/api-client/types";
import { CoreButton } from "@verity/components/core";
import { forwardRef } from "react";
import i18n from "../../../../../i18n";
import { AiSummaryButton } from "../Summary";

type SummaryButtonProps = {
	loading?: boolean;
	sessionSummary?: ProctoringSessionSummary;
	isLiveSessionProctor?: boolean;
	showSummary: () => void;
	showAiSummary: () => void;
};

/** Forwards a ref so callers can hand focus back to whichever of the two buttons is rendered. */
const SummaryButton = forwardRef<HTMLButtonElement, SummaryButtonProps>(function SummaryButton(props, ref) {
	const { loading, sessionSummary, isLiveSessionProctor, showSummary, showAiSummary } = props;

	if (sessionSummary?.source === "liveProctor" || isLiveSessionProctor) {
		return (
			<CoreButton ref={ref} onClick={showSummary} disabled={loading}>
				{i18n.t("result.components.studentSelection.videoPlayer.videoPlayerTSX.summaryButton") as string}
			</CoreButton>
		);
	}

	return <AiSummaryButton ref={ref} onClick={showAiSummary} disabled={loading} />;
});

export default SummaryButton;
